import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../../api'; 


export const getSearchedExercises = createAsyncThunk(
  'drag/getSearchedExercises',
  async (searchTerm , { rejectWithValue }) => {
    try {
      const response = await api.post(`${process.env.REACT_APP_API_BASE_URL}/admin/exercises-list?page=1`, {
        searchTerm:searchTerm
      });
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to fetch exercises');
    }
  }
);

// Async thunk to fetch exercises data
export const getExercisesByDayAndWeek = createAsyncThunk(
  'drag/getExercisesByDayAndWeek',
  async ({ day_number = 1, week_number = '', training_program_id = '' }, { rejectWithValue }) => {
    try {
      const response = await api.post(`${process.env.REACT_APP_API_BASE_URL}/admin/get-exercises-by-day-and-week`, {
        day_number,
        week_number,
        training_program_id,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to fetch exercises');
    }
  }
);

// Async thunk to delete exercises
export const deleteExercisesByDayAndWeek = createAsyncThunk(
  'drag/deleteExercisesByDayAndWeek',
  async ({ day_number = 1, week_number = '', training_program_id = '', exercise_id = '' }, { rejectWithValue }) => {
    try {
      const response = await api.post(`${process.env.REACT_APP_API_BASE_URL}/admin/delete-exercises-by-day-and-week`, {
        day_number,
        week_number,
        training_program_id,
        exercise_id,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to delete exercises');
    }
  }
);

// Async thunk to add exercises
export const addExercisesByDayAndWeek = createAsyncThunk(
  'drag/addExercisesByDayAndWeek',
  async ({ day_number = 1, week_number = '', training_program_id = '', exercise_id = '', sequence = '' }, { rejectWithValue }) => {
    try {
      const response = await api.post(`${process.env.REACT_APP_API_BASE_URL}/admin/add-exercises-by-day-and-week`, {
        day_number,
        week_number,
        training_program_id,
        exercise_id,
        sequence
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to add exercises');
    }
  }
);

export const updateSequence = createAsyncThunk(
  'drag/updateSequence',
  async ({ id = '', sequence = 'A' }, { rejectWithValue }) => {
    try {
      const response = await api.post(`${process.env.REACT_APP_API_BASE_URL}/admin/update-sequence-for-exercise`, {
        id:id,
        sequence:sequence
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to add exercises');
    }
  }
);

export const updateSets = createAsyncThunk(
  'drag/updateSets',
  async ({ id = '', sets = '' }, { rejectWithValue }) => {
    try {
      const response = await api.post(`${process.env.REACT_APP_API_BASE_URL}/admin/update-sets`, {
        id:id,
        sets:sets
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to add exercises');
    }
  }
);

export const updateReps = createAsyncThunk(
  'drag/updateReps',
  async ({ id = '', reps = '' }, { rejectWithValue }) => {
    try {
      const response = await api.post(`${process.env.REACT_APP_API_BASE_URL}/admin/update-reps`, {
        id:id,
        reps:reps
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to add exercises');
    }
  }
);



export const copyWeek = createAsyncThunk(
  'drag/copyWeek',
  async ({ training_program_id = '', selected_week_number = 'A', new_week_number='' }, { rejectWithValue }) => {
    try {
      const response = await api.post(`${process.env.REACT_APP_API_BASE_URL}/admin/copy-week`, {
        training_program_id:training_program_id,
        selected_week_number:selected_week_number,
        new_week_number:new_week_number
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to add exercises');
    }
  }
);

export const copyDay = createAsyncThunk(
  'drag/copyDay',
  async ({  training_program_id = '', week_number = 'A', selected_day_number='', new_day_number='', new_week_number='' }, { rejectWithValue }) => {
    try {
      const response = await api.post(`${process.env.REACT_APP_API_BASE_URL}/admin/copy-day`, {
        training_program_id:training_program_id,
        week_number:week_number,
        selected_day_number:selected_day_number,
        new_day_number:new_day_number,
        new_week_number:new_week_number
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to add exercises');
    }
  }
);

export const updateExerciseEntryNote = createAsyncThunk(
  'drag/updateExerciseEntryNote',
  async ({ exercise_id='', notes=''}, {dispatch}) => {
    const response = await api.post(`${process.env.REACT_APP_API_BASE_URL}/admin/update-exercise-entry-notes`, {
      exercise_id: exercise_id,
      notes:notes
    });
      
    return response.data;
  }
);


const dragSlice = createSlice({
  name: 'drag',
  initialState: {
    isLoading:false,
    ExercisesByDayAndWeek: [],
    SearchedExercises:[],
    categories: [],
    successMessage: null,
    errorMessage: null,
    isCopySuccess:false,
  },
  reducers: {
    setVideoPage: (state, action) => {
      state.currentVideoPage = action.payload;
    },
    setCategoryPage: (state, action) => {
      state.currentCategoryPage = action.payload;
    },
    clearMessages: (state) => {
      state.isLoading = false;
      state.error = null;
      state.successMessage = null;
      state.errorMessage = null;
      state.SearchedExercises = [];
      state.ExercisesByDayAndWeek = [];
      state.isCopySuccess = false;
    },
  },
  extraReducers: (builder) => {
    builder
    .addCase(getSearchedExercises.fulfilled, (state, action) => {
        state.SearchedExercises = action.payload.data;
        state.successMessage = null;
        state.errorMessage = null;
      })
      .addCase(getSearchedExercises.rejected, (state, action) => {
        state.error = action.payload.message;
        state.successMessage = null;
        state.errorMessage = null;
      })
      .addCase(getExercisesByDayAndWeek.fulfilled, (state, action) => {
        state.ExercisesByDayAndWeek = action.payload.data;
        state.successMessage = null;
        state.errorMessage = null;
      })
      .addCase(getExercisesByDayAndWeek.rejected, (state, action) => {
        state.error = action.payload.message;
        state.successMessage = null;
        state.errorMessage = null;
      })
      .addCase(deleteExercisesByDayAndWeek.fulfilled, (state, action) => {
        state.ExercisesByDayAndWeek = action.payload.data;
        state.successMessage = null;
        state.errorMessage = null;
      })
      .addCase(deleteExercisesByDayAndWeek.rejected, (state, action) => {
        state.error = action.payload.message;
        state.successMessage = null;
        state.errorMessage = null;
      })
      .addCase(addExercisesByDayAndWeek.fulfilled, (state, action) => {
        state.ExercisesByDayAndWeek = action.payload.data;
        state.successMessage = null;
        state.errorMessage = null;
      })
      .addCase(addExercisesByDayAndWeek.rejected, (state, action) => {
        state.error = action.payload.message;
        state.successMessage = null;
        state.errorMessage = null;
      })
      .addCase(updateSequence.rejected, (state, action) => {
        state.error = action.payload.message;
        state.successMessage = null;
        state.errorMessage = null;
      })
      .addCase(updateSets.rejected, (state, action) => {
        state.error = action.payload.message;
        state.successMessage = null;
        state.errorMessage = null;
      })
      .addCase(updateReps.rejected, (state, action) => {
        state.error = action.payload.message;
        state.successMessage = null;
        state.errorMessage = null;
      })
       .addCase(copyWeek.pending, (state, action) => {
        state.successMessage = null;
        state.errorMessage = null;
        state.isLoading = true;
        state.isCopySuccess = false;
      })
      .addCase(copyWeek.fulfilled, (state, action) => {
        state.successMessage = null;
        state.errorMessage = null;
        state.isLoading = false;
        state.isCopySuccess = true;
      })
      .addCase(copyWeek.rejected, (state, action) => {
        state.successMessage = null;
        state.errorMessage = null;
        state.isLoading = false;
        state.isCopySuccess = false;
      })
      .addCase(copyDay.pending, (state, action) => {
        state.successMessage = null;
        state.errorMessage = null;
        state.isLoading = true;
        state.isCopySuccess = false;
      })
      .addCase(copyDay.fulfilled, (state, action) => {
        state.successMessage = null;
        state.errorMessage = null;
        state.isLoading = false;
        state.isCopySuccess = true;
      })
      .addCase(copyDay.rejected, (state, action) => {
        state.successMessage = null;
        state.errorMessage = null;
        state.isLoading = false;
        state.isCopySuccess = false;
      })
      .addCase(updateExerciseEntryNote.fulfilled, (state, action) => {
        
      })
      .addCase(updateExerciseEntryNote.rejected, (state, action) => {
        state.error = action.payload; // Handle error on rejection
      });
  },
});

export const { clearMessages } = dragSlice.actions;
export default dragSlice.reducer;